import { IHierarchicalDepartmentDTO } from 'src/api/dtos';

export const getAllChildDepartmentIds = (department: IHierarchicalDepartmentDTO, result: number[] = []) => {
  result.push(department.id);
  if (department.children?.length) {
    department.children.forEach((child) => {
      result = getAllChildDepartmentIds(child, result);
    });
  }
  return result;
};

export const getDepartmentById = (
  departments: IHierarchicalDepartmentDTO[],
  id: string,
  result: IHierarchicalDepartmentDTO | null = null,
) => {
  departments.forEach((department) => {
    if (department.id.toString() === id) {
      result = department;
    } else if (department.children?.length) {
      result = getDepartmentById(department.children, id, result);
    }
  });
  return result;
};

export const getChildDepartmentIdsToLevel = (
  departments: IHierarchicalDepartmentDTO[],
  level = Infinity,
  result: string[] = [],
) => {
  departments.forEach((department) => {
    result.push(department.id.toString());
    if (department.children?.length && level > 0) {
      result = getChildDepartmentIdsToLevel(department.children, level - 1, result);
    }
  });
  return result;
};
